import type { HomeLocation } from "./ai-chat";
import type { PlaceForecast } from "./weather";

export function googleMapsDirections(place: Pick<PlaceForecast, "name" | "region" | "latitude" | "longitude">, home?: HomeLocation): string {
  const url = new URL("https://www.google.com/maps/dir/");
  url.searchParams.set("api", "1");
  url.searchParams.set("destination", [place.name, place.region, "Italia"].filter(Boolean).join(", "));
  url.searchParams.set("travelmode", "driving");
  if (home) url.searchParams.set("origin", home.label);
  return url.toString();
}
